import {useAxiosClient} from "~/use/axios/client";
import {GmModelLibraryModelsPlantingStandardModel, PlantingStandardApi} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {useOnline} from "@vueuse/core";
import {queryClient} from "~/plugins/vue-query";

export const usePlantingStandardService = () => {
    const { axiosClient } = useAxiosClient()
    const plantingStandardApi = new PlantingStandardApi(undefined, '', axiosClient.value)
    const isOnline = useOnline()

    const plantingStandardQueryOptions: UseQueryOptions<GmModelLibraryModelsPlantingStandardModel[]> = {
        queryKey: ['plantingStandardGetPlantingStandards'],
        queryFn: async () => {
            return (await plantingStandardApi.plantingStandardGetPlantingStandards())?.data
        },
        staleTime: MS_HOUR,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        gcTime: Infinity,
        enabled: isOnline,
    }

    const plantingStandardQuery = () => useQuery(plantingStandardQueryOptions)

    const plantingStandard = computed<GmModelLibraryModelsPlantingStandardModel[]>(() => queryClient.getQueryData(plantingStandardQueryOptions.queryKey) || [])

    return {
        plantingStandardQueryOptions,
        plantingStandardQuery,
        plantingStandard,
    }
}